'use strict'

const formatters = require('./formatters')

function addFormatter () {
  if (arguments.length === 2) {
    const [countryCode, formattersToAdd] = arguments
    if (!formatters[countryCode]) {
      formatters[countryCode] = {}
    }
    for (const format in formattersToAdd) {
      formatters[countryCode][format] = formattersToAdd[format]
    }
  } else {
    const [countryCode, format, formatter] = arguments
    if (!formatters[countryCode]) {
      formatters[countryCode] = {}
    }
    formatters[countryCode][format] = formatter
  }
}

function formatHTML (...args) {
  const lines = format(...args)
  const escaped = lines.map(line => line.replace(/</g, '&lt;').replace(/>/g, '&gt;'))
  return escaped.join('<br />\n')
}

function format (address, countryCode, format) {
  if (!formatters[countryCode]) {
    if (process.env.NODE_ENV === 'development') {
      return [`Unknown address formatter (${countryCode})`]
    } else {
      return ['']
    }
  }

  const country = formatters[countryCode]
  const formatter = country[format]

  return formatter(address)
}

module.exports = {
  addFormatter,
  format,
  formatHTML
}
